import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export interface EquipmentList {
  eid: number;
  label: string;
  sn: string;
}

export interface IHelpdeskContract {
  agreeId: number;
  billingPeriod?: number;
  cancellationDate?: string;
  date?: string;
  entid?: number;
  entityName?: string;
  equiType?: number;
  equipmentList?: EquipmentList[];
  firstLine?: boolean;
  firstLineValue?: number;
  firstLineDate?: string;
  handWork?: boolean;
  invoiceState?: number;
  lastInvoiceDate?: string;
  lastRevDate?: string;
  newSWReleases?: boolean;
  newSWReleasesValue?: number;
  newSWReleasesDate?: string;
  nextInvoiceDate?: string;
  parts?: boolean;
  partsDate?: string;
  partsValue?: number;
  processing?: boolean;
  processingValue?: number;
  processingDate?: string;
  renovDate?: string;
  revType?: number;
  revValue?: number;
  secondLine?: boolean;
  secondLineDate?: string;
  secondLineValue?: number;
  slaId?: number;
  state?: number;
  validity?: number;
  value?: number;
  warrantyParts?: boolean;
  warrantyPartsValue?: number;
  warrantyPartsDate?: string;
  webPlatform?: boolean;
  webPlatformValue?: number;
  webPlatformDate?: string;
}

export type IHelpdeskContractRequest = IHelpdeskContract;

export interface IHelpdeskContractsResponse extends ApiResponse {
  list: IHelpdeskContract[];
  totalRows: number;
  type: string;
}

export interface IHelpdeskContractInfoResponse extends ApiResponse {
  list: IHelpdeskContract[];
  totalRows: number;
  type: string;
}

export interface IEquipmentOptionListResponse extends ApiResponse {
  list: EquipmentList[];
  type: string;
  totalRows: number;
}

export const fetchHelpdeskContracts = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  entid?: number,
  agreeId?: number
): Promise<AxiosResponse<IHelpdeskContractsResponse>> => {
  const url =
    `${zps_ms_ea_war}/agreement?offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (entid ? `&entid=${entid}` : '') +
    (agreeId ? `&agreeId=${agreeId}` : '');

  return axios.get<IHelpdeskContractsResponse>(url, {
    signal: controller.signal
  });
};

export const fetchHelpdeskContractInfo = (
  agreeId: number,
  controller: AbortController
): Promise<AxiosResponse<IHelpdeskContractInfoResponse>> => {
  const url = `${zps_ms_ea_war}/agreement?agreeId=${agreeId}`;

  return axios.get<IHelpdeskContractInfoResponse>(url, {
    signal: controller.signal
  });
};

export const fetchHelpdeskContractEquipInfo = (
  agreeId: number,
  controller: AbortController
): Promise<AxiosResponse<IEquipmentOptionListResponse>> => {
  const url = `${zps_ms_ea_war}/agreement/option/equipment?agreeId=${agreeId}`;

  return axios.get<IEquipmentOptionListResponse>(url, {
    signal: controller.signal
  });
};

export const addHelpdeskContract = (
  request: IHelpdeskContractRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_ms_ea_war}/agreement/`, request, { signal: controller.signal });
};

export const updateHelpdeskContract = (
  request: IHelpdeskContractRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.put<ApiResponse>(`${zps_ms_ea_war}/agreement/`, request, { signal: controller.signal });
};

export const copyHelpdeskContract = (
  request: IHelpdeskContractRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_ms_ea_war}/agreement/`, request, { signal: controller.signal });
};

export const deleteHelpdeskContract = (
  agreeId: number,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_ms_ea_war}/agreement?agreeId=${agreeId}`;

  return axios.delete<ApiResponse>(url, {
    signal: controller.signal
  });
};
